import {captureError} from "../modules/helpers.js";

let idbAdapter;
try {
    idbAdapter = new LokiIndexedAdapter();
} catch (err) {
    notie.alert({
        type: 3, text: 'Your browser is not supported. Please try playing on another browser like Chrome.',
        stay: true
    });
    throw err;
}
export let db;
let Superstars, TagTeams, Championships, Matches, Games, Companies, Events, Rosters, Scenarios, ChampionshipReigns, Streaks,
    Brands, Factions, CompanyLogs, GimmickMatches, CompanyAlerts, NewsItems, Objectives, Properties, Relationships, Powerups,
    MatchContracts, StoryChoices, Tournaments, Feuds, FeudItems, Segments, SegmentItems, Gimmicks, Characters, Messages,
    RandomEvents, StaffMembers, Facilities, YearlyRankings, Drafts, Negotiations, TradeOffers, TalentRequests,
    MatchesHash, TagTeamsHash, FactionsHash, ChampionshipReignMatchesHash, FeudParticipantsHash, SegmentParticipantsHash,
    FeudMatchesHash, FeudSegmentsHash;

async function databaseInitialize() {

    // Get collections
    Superstars = db.getCollection("Superstars");
    TagTeams = db.getCollection("TagTeams");
    Championships = db.getCollection("Championships");
    Matches = db.getCollection("Matches");
    Games = db.getCollection("Games");
    Companies = db.getCollection("Companies");
    Events = db.getCollection("Events");
    Rosters = db.getCollection("Rosters");
    Scenarios = db.getCollection("Scenarios");
    ChampionshipReigns = db.getCollection("ChampionshipReigns");
    Streaks = db.getCollection("Streaks");
    Brands = db.getCollection("Brands");
    Factions = db.getCollection("Factions");
    CompanyLogs = db.getCollection("CompanyLogs");
    GimmickMatches = db.getCollection("GimmickMatches");
    CompanyAlerts = db.getCollection("CompanyAlerts");
    NewsItems = db.getCollection("NewsItems");
    Objectives = db.getCollection("Objectives");
    Properties = db.getCollection("Properties");
    Relationships = db.getCollection("Relationships");
    Powerups = db.getCollection("Powerups");
    MatchContracts = db.getCollection("MatchContracts");
    StoryChoices = db.getCollection("StoryChoices");
    Tournaments = db.getCollection("Tournaments");
    Feuds = db.getCollection("Feuds");
    FeudItems = db.getCollection("FeudItems");
    Segments = db.getCollection("Segments");
    SegmentItems = db.getCollection("SegmentItems");
    Gimmicks = db.getCollection("Gimmicks");
    Characters = db.getCollection("Characters");
    Messages = db.getCollection("Messages");
    RandomEvents = db.getCollection("RandomEvents");
    StaffMembers = db.getCollection("StaffMembers");
    Facilities = db.getCollection("Facilities");
    YearlyRankings = db.getCollection("YearlyRankings");
    Drafts = db.getCollection("Drafts");
    Negotiations = db.getCollection("Negotiations");
    TradeOffers = db.getCollection("TradeOffers");
    TalentRequests = db.getCollection("TalentRequests");
    MatchesHash = db.getCollection("MatchesHash");
    TagTeamsHash = db.getCollection("TagTeamsHash");
    FactionsHash = db.getCollection("FactionsHash");
    ChampionshipReignMatchesHash = db.getCollection("ChampionshipReignMatchesHash");
    FeudParticipantsHash = db.getCollection("FeudParticipantsHash");
    SegmentParticipantsHash = db.getCollection("SegmentParticipantsHash");
    FeudMatchesHash = db.getCollection("FeudMatchesHash");
    FeudSegmentsHash = db.getCollection("FeudSegmentsHash");

    if (Superstars === null) {
        // Initialize collections upon first load
        Superstars = db.addCollection("Superstars");
        TagTeams = db.addCollection("TagTeams");
        Championships = db.addCollection("Championships");
        Matches = db.addCollection("Matches");
        Games = db.addCollection("Games");
        Companies = db.addCollection("Companies");
        Events = db.addCollection("Events");
        Rosters = db.addCollection("Rosters");
        Scenarios = db.addCollection("Scenarios");
        ChampionshipReigns = db.addCollection("ChampionshipReigns");
        Streaks = db.addCollection("Streaks");
        Brands = db.addCollection("Brands");
        Factions = db.addCollection("Factions");
        CompanyLogs = db.addCollection("CompanyLogs");
        GimmickMatches = db.addCollection("GimmickMatches");
        CompanyAlerts = db.addCollection("CompanyAlerts");
        NewsItems = db.addCollection("NewsItems");
        Objectives = db.addCollection("Objectives");
        Properties = db.addCollection("Properties");
        Relationships = db.addCollection("Relationships");
        Powerups = db.addCollection("Powerups");
        MatchContracts = db.addCollection("MatchContracts");
        StoryChoices = db.addCollection("StoryChoices");
        Tournaments = db.addCollection("Tournaments");
        Feuds = db.addCollection("Feuds");
        FeudItems = db.addCollection("FeudItems");
        Segments = db.addCollection("Segments");
        SegmentItems = db.addCollection("SegmentItems");
        Gimmicks = db.addCollection("Gimmicks");
        Characters = db.addCollection("Characters");
        Messages = db.addCollection("Messages");
        RandomEvents = db.addCollection("RandomEvents");
        StaffMembers = db.addCollection("StaffMembers");
        Facilities = db.addCollection("Facilities");
        YearlyRankings = db.addCollection("YearlyRankings");
        Drafts = db.addCollection("Drafts");
        Negotiations = db.addCollection("Negotiations");
        TradeOffers = db.addCollection("TradeOffers");
        TalentRequests = db.addCollection("TalentRequests");
        MatchesHash = db.addCollection("MatchesHash");
        TagTeamsHash = db.addCollection("TagTeamsHash");
        FactionsHash = db.addCollection("FactionsHash");
        ChampionshipReignMatchesHash = db.addCollection("ChampionshipReignMatchesHash");
        FeudParticipantsHash = db.addCollection("FeudParticipantsHash");
        SegmentParticipantsHash = db.addCollection("SegmentParticipantsHash");
        FeudMatchesHash = db.addCollection("FeudMatchesHash");
        FeudSegmentsHash = db.addCollection("FeudSegmentsHash");

        // Set max id to prevent potential collisions
        TagTeams.maxId = 20000;
        Factions.maxId = 10000;
        Segments.maxId = 100000;

        // Load initial data

        db.saveDatabase();
    }
}

async function loadDb(uuid, jsonData) {
    return new Promise((resolve, reject) => {
        db = new loki(uuid, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: async (err) => {
                if (err) {
                    captureError(new Error(err))
                    notie.alert({type: 3, text: "There was an error loading the database. Please try again."});
                }
                else {
                    if (jsonData) {
                        db.loadJSONObject(jsonData);
                    }
                    await databaseInitialize();
                    resolve();
                }
            }
        });
    })
}

async function deleteDb(uuid) {
    return new Promise((resolve, reject) => {
        idbAdapter.deleteDatabase(uuid, function () {
            resolve()
        });
    })
}

export {Superstars, TagTeams, Championships, Matches, Games, Companies, Events, Rosters, Scenarios, ChampionshipReigns, Streaks,
        Brands, Factions, CompanyLogs, GimmickMatches, CompanyAlerts, NewsItems, Objectives, Properties, Relationships, Powerups,
        MatchContracts, StoryChoices, Tournaments, Feuds, FeudItems, Segments, SegmentItems, Gimmicks, Characters, Messages,
        RandomEvents, StaffMembers, Facilities, YearlyRankings, Drafts, Negotiations, TradeOffers, TalentRequests,
        MatchesHash, TagTeamsHash, FactionsHash, ChampionshipReignMatchesHash, FeudParticipantsHash, SegmentParticipantsHash,
        FeudMatchesHash, FeudSegmentsHash, loadDb, deleteDb}